export default "__VITE_ASSET__Lm9t7oZQ__"